var map = {
	"./arms.png": 5232,
	"./booster.png": 3585,
	"./core.png": 5088,
	"./expansion.png": 5998,
	"./fcs.png": 3729,
	"./generator.png": 3426,
	"./head.png": 699,
	"./leftArm.png": 3570,
	"./leftBack.png": 1063,
	"./legs.png": 9626,
	"./rightArm.png": 4129,
	"./rightBack.png": 4446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 734;